export function iconClipboard({ className }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 60 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25.3333 50.1667L48.8333 26.6667L44.1667 22L25.3333 40.8333L15.8333 31.3333L11.1667 36L25.3333 50.1667ZM6.66667 66.6667C4.83333 66.6667 3.26389 66.0139 1.95833 64.7083C0.652778 63.4028 0 61.8333 0 60V13.3333C0 11.5 0.652778 9.93056 1.95833 8.625C3.26389 7.31944 4.83333 6.66667 6.66667 6.66667H20.6667C21.3889 4.66667 22.5972 3.05556 24.2917 1.83333C25.9861 0.611111 27.8889 0 30 0C32.1111 0 34.0139 0.611111 35.7083 1.83333C37.4028 3.05556 38.6111 4.66667 39.3333 6.66667H53.3333C55.1667 6.66667 56.7361 7.31944 58.0417 8.625C59.3472 9.93056 60 11.5 60 13.3333V60C60 61.8333 59.3472 63.4028 58.0417 64.7083C56.7361 66.0139 55.1667 66.6667 53.3333 66.6667H6.66667ZM6.66667 60H53.3333V13.3333H6.66667V60ZM31.7917 10.125C32.2639 9.65278 32.5 9.05556 32.5 8.33333C32.5 7.61111 32.2639 7.01389 31.7917 6.54167C31.3194 6.06944 30.7222 5.83333 30 5.83333C29.2778 5.83333 28.6806 6.06944 28.2083 6.54167C27.7361 7.01389 27.5 7.61111 27.5 8.33333C27.5 9.05556 27.7361 9.65278 28.2083 10.125C28.6806 10.5972 29.2778 10.8333 30 10.8333C30.7222 10.8333 31.3194 10.5972 31.7917 10.125Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
